// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-styling {\n    left: 0 !important;\n    padding: 0 !important;\n    right: 0 !important;\n    width: 100%;\n    height: 100%;\n    overflow: scroll;\n}\n\n\n.checkmark::before {\n    display: none !important;\n}  \n.checkmark::after {\n    left: 4px !important;\n    top: -7px !important;\n    width: 11px !important;\n    height: 25px !important;\n    border: 1px solid #FC6522 !important;\n    border-width: 0 3px 3px 0 !important;\n}   ", ""]);
// Exports
module.exports = exports;
